/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_FairValue_FairValueImportParseDto } from '../models/Wealthlane_AwardService_Dtos_FairValue_FairValueImportParseDto';
import type { Wealthlane_AwardService_Dtos_FairValue_FairValueImportResponseDto } from '../models/Wealthlane_AwardService_Dtos_FairValue_FairValueImportResponseDto';
import type { Wealthlane_AwardService_Dtos_FairValue_FairValueImportSampleFileBlobDto } from '../models/Wealthlane_AwardService_Dtos_FairValue_FairValueImportSampleFileBlobDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FairValueService {

    /**
     * @param formData 
     * @returns Wealthlane_AwardService_Dtos_FairValue_FairValueImportResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppFairValueImportFairValue(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_AwardService_Dtos_FairValue_FairValueImportResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/fair-value/import-fair-value',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_FairValue_FairValueImportSampleFileBlobDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppFairValueDownloadFairValueImportSample(): CancelablePromise<Wealthlane_AwardService_Dtos_FairValue_FairValueImportSampleFileBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/fair-value/download-fair-value-import-sample',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_FairValue_FairValueImportParseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFairValueFairValueById(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_FairValue_FairValueImportParseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/fair-value/fair-value-by-id/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param awardId 
     * @param awardType 
     * @returns Wealthlane_AwardService_Dtos_FairValue_FairValueImportParseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFairValueFairValueByAwardId(
awardId: string,
awardType?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_FairValue_FairValueImportParseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/fair-value/fair-value-by-award-id/{AwardId}',
            path: {
                'AwardId': awardId,
            },
            query: {
                'AwardType': awardType,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
